export const ADUNIT_SIZE = {
  FIXED: 'fixed',
  RESPONSIVE: 'responsive',
} as const;

export type AdunitSize = (typeof ADUNIT_SIZE)[keyof typeof ADUNIT_SIZE];

export type Dimensions = {
  height: number;
  width: number;
};
